module.exports = __webpack_public_path__ + "img/refund-line.5341bb79.svg";